import { render, staticRenderFns } from "./BiddingAgent.vue?vue&type=template&id=465493f3&scoped=true&"
import script from "./BiddingAgent.vue?vue&type=script&lang=js&"
export * from "./BiddingAgent.vue?vue&type=script&lang=js&"
import style0 from "./BiddingAgent.vue?vue&type=style&index=0&id=465493f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465493f3",
  null
  
)

export default component.exports